/* 全局参数 */
import { getStorage, setStorage, batchSetStorage } from '@/libs/utils'
import { Toast } from 'vant';
import { gameOpenDownloads } from '@/bridge/AppJsBridge'
import { getOfficialInfo } from '@/api/user';
import { cdnLink } from '@/config';

const state = {
  /* H5部分单独使用 */
  outer: '', // ios h5包链接若拼接此参数值为turn，支付窗口打开后在几秒后自动关闭支付窗口
  hidefloat: '',
  store_type: 0,
  /* -------------------- */
  /*  原生单独使用   */

  /*  ----------------   */
  /*      通用部分    */
  sdk_version: '',
  bridgeInitFlag: false,
  policyVisible: false,
  preventBrush: false, // 防重复点击标识
  officialInfo: {}, // 公众号推荐页显示相关内容
  loadingToast: null
  /*  ----------------   */
};

const mutations = {
  CHANGE_STATE: (state, obj) => {
    state = Object.assign(state, obj);
  },
  handleLinkParams: (state, query) => {
    const { outer, hidefloat, store_type } = query;
    // ios h5支付后关闭支付界面
    state.outer = outer || false;
    state.hidefloat = hidefloat;
    state.store_type = store_type || 0;
    setStorage('store_type', store_type);
    if (hidefloat) setStorage('hidefloat', true);
  },
  // loading
  // showLoading(state, msg: string) {
  //   state.loadingVisible = true;
  // },
  // clearLoading(state) {
  //   state.loadingVisible = false;
  // },
  // loading
  showLoading(state, msg) {
    state.loadingToast = Toast.loading({
      overlay: false,
      forbidClick: true,
      message: msg || '',
      duration: 2000, // 持续展示 toast
      icon: `${cdnLink}/loading.gif?v=1`
    });
  },
  clearLoading(state) {
    state.loadingToast && state.loadingToast.clear();
  },
  showSuccessToast(state, msg) {
    Toast.success(msg);
  },
  showCommonToast(state, msg) {
    Toast(msg);
  }
};

const actions = {
  // 跳转浏览器打开在线客服链接
  async openCustomer({ }, data) {
    let url = process.env.NODE_ENV === 'production' ? `${window.location.origin}/h5sdk/h5/manualCustomer?v=${Math.floor(Math.random() * 10000)}` : 'https://sdk-h5.zhangyuqu.com/h5sdk/h5/manualCustomer?v=' + Math.floor(Math.random() * 10000);
    const account = getStorage('username');
    const game = getStorage('p_name');
    const appkey = getStorage('appkey');

    url = `${url}&account=${account}&appkey=${appkey}&server=${data ? data.server : ''}&role_name=${data ? data.role_name : ''}`;

    gameOpenDownloads({
      gameUrl: url
    })
  },
  // 获取客服链接
  async getCustomerLink({ rootState }) {
    const data = rootState.suspend.role
    let url = `${window.location.origin}/h5sdk/h5/manualCustomer?v=${Math.floor(Math.random() * 10000)}`;
    const account = getStorage('username');
    const game = getStorage('p_name');
    const appkey = getStorage('appkey');

    url = `${url}&account=${account}&appkey=${appkey}&server=${data ? (data.server || data.server_name || '') : ''}&role_name=${data ? (data.role_name || '') : ''}`;
    console.log("-----客服-----", url)
    return url
  },
  // 获取带角色信息的工单URL
  async getWorkSnLink({ rootState }, roleInfo) {
    return ''
  },
  // 获取公众号推荐内容
  async getOfficialInfo({ rootState, commit }, data) {
    const { user_id, access_token, appkey } = rootState.user;
    console.log(user_id, access_token, appkey)
    const r = await getOfficialInfo({ user_id, access_token, appkey });
    commit('CHANGE_STATE', { officialInfo: r.content });
    if (r.content.official_status === 1) {
      commit('user/CHANGE_STATE', { official_status: 1 }, { root: true });
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
